var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5443_45717",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5443_45717",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACTklEQVRo3u2aPU/CQByHGWQihJjAZ9BYXwa0IHF28aWRjaBE/QagK5MmOjjwQUQXFwfFiDooYBg1bvABlCiJSlJ/f9OGplRasKV3xkuepXe9e37XUtprPZ7/0i4vVwE/iIIkyICsQkbZRnV+ZoQbV8MkHQZ7oAJaQDaB2tyDfTDduA64MtNesAGqFoTNoD42qU/nZ7z4PeMr4MkGcT3UZ/y5GHBs1kPg2AFxPTRGyG55EdQHIK9CY0Xskl8EzQHKq9CYS3bIv7sgr/LRdwjltHlzUV57JMRe5YOgxoC8CrkELV4q/RQgz5C8Sv75MmBp9iUG5VUkM/kh8MBwgEdy7BZgjWF5lZSh/GvBRwFKHAQoN24MbmiTJwtTB6dRmQdW4doRYORofQfInLBrFOCOowB3enkf+OQoALn6tAFEjuRVRG2ABIcBEtoAaQ4DpLUBshwGyP6pANyfQtz/iLm/jPL9R8bhrcSt0b3QLkcBdjoCSLn41Nb2vLzNOOS4nItPdgQoiqOei1mhDGTGKRVmBONHSlSmOAiw9uMzMSqHwCPD8g/k2HVlAg0khgNIputC53MChcgzKH94Fhu3trSIxkFQY0ieXII9rY9iBxE0GZB/I5e+Vqix4xJ4d1Gexl781TsCJYQbR6L5a3lNiAioD1C+3vdp0yVECBwPQJ7GsPclXzvEGAWJgycHxKnPlYvZcY/jBQN5wQao2iBeVfpy/kW3vhRiExQmDPZABbQsCLeUtrRP+DwmsPOxB4T8IAqSIAOyChllG9Wx87EHC+ULuxgcpNZoSKcAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM2);
export default __webpack_public_path__ + "static/media/m2.f4197c06c6f3ccf1a41e4d034fcf4903.svg";
export { ForwardRef as ReactComponent };